import { IonHeader, IonText } from '@ionic/react';
import { colorConstants } from '../../theme/mindly_constants';
import styled from 'styled-components';
import { ContentBox } from '../../theme/Boxes.style';

type UserProfileIonHeaderProps = {
  isDisable: boolean;
  isIos: boolean;
  internetConnection: boolean;
};

export const UserProfileIonHeader = styled(IonHeader)<UserProfileIonHeaderProps>`
  height: 64px;
  box-shadow: 0 2px 4px rgb(0 0 0 / 5%);
  position: relative;
  margin-top: ${(props) => (!props.internetConnection ? '14px' : '0')};
  padding-bottom: ${(props) => (!props.internetConnection ? '3px' : '0')};

  h4 {
    position: absolute;
    top: 15px;
    right: 10px;
    color: ${(props) => (props.isDisable ? colorConstants.AccentDisabledColor : colorConstants.primaryColor)};
  }

  ::after {
    display: none;
  }

  @media only screen and (min-height: 800px) {
    margin-top: ${(props) => (!props.internetConnection ? (props.isIos ? '8px' : '14px') : props.isIos ? '10px' : '0')};
  }
`;

export const UserProfileSaveIonText = styled(IonText)`
  margin: 0 auto 20px;
  text-align: center;

  h4 {
    font-weight: 600;
    font-size: 16px;
    line-height: 24px;
    color: ${colorConstants.primaryColor};
  }

  h4.input-text {
    margin-top: -20px;
    margin-bottom: 0;
    cursor: pointer;
  }

  .inputfile-info {
    overflow: hidden;
    opacity: 0;
    width: 200px;
    margin: 0 auto;
    display: block;
    cursor: pointer;
  }
`;

type AvatarProps = {
  isLoading: boolean;
};

export const Avatar = styled.img<AvatarProps>`
  visibility: ${(props) => (props.isLoading ? 'hidden' : 'visible')};
  width: 170px;
  height: 170px;
  margin: 0 auto;
  border-radius: 50%;

  .image-info {
    width: 180px;
    border-radius: 50%;
    height: 180px;
  }
`;

export const StyledImageInfoWrapper = styled.div`
  text-align: center;
  position: relative;
  display: flex;
  justify-content: center;

  .image-info {
    object-fit: cover;
  }

  .letter-avatar {
    height: 170px;
    width: 170px;
    font-size: 48px;
    flex: 0 0 170px;
  }
`;

type NavBarProps = {
  isDisabled: boolean;
};

export const SaveBtnContainer = styled.h4<NavBarProps>`
  cursor: pointer;
  color: ${(props) => (props.isDisabled ? colorConstants.AccentDisabledColor : colorConstants.primaryColor)} !important;
`;

export const InputContainer = styled.div`
  display: grid;
  grid-row-gap: 24px;
  padding: 16px 0;
  width: 100%;
`;

export const ButtonContainer = styled(ContentBox)`
  display: grid;
  grid-row-gap: 24px;
  margin-bottom: 15px;
  @media (min-width: 900px) {
    margin: 0 auto 85px;
  }
`;

export const ChangeAvatarButton = styled.button`
  margin-top: 16px;
  background: none;
  font-weight: 600;
  font-size: 16px;
  line-height: 24px;
  color: #177590;
`;

export const RevokeWrapper = styled.button`
  border: none;
  outline: none;
  background: transparent;
  display: flex;
  align-items: center;
  column-gap: 10px;
  font-weight: 600;
  font-size: 14px;
  line-height: 16px;
  color: #5b5b5b;

  & ion-icon {
    font-size: 24px;
  }
`;
